import {ref} from 'vue'

export const contaBaseUrl = ref('')

const resolveApiPath = (): string => {
    return contaBaseUrl.value
}

const resolvePracsysApiPath = () => {
    return `${resolveApiPath()}/pracsys`
}

const resolvePatronApiPath = () => {
    return `${resolveApiPath()}/patron`
}

const resolveEhfApiPath = () => {
    return `${resolveApiPath()}/ehf-service`
}

export {
    resolvePracsysApiPath,
    resolvePatronApiPath,
    resolveEhfApiPath,
    resolveApiPath
}